import React, { useState, useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';

export const TiltCard = ({ children, className = '' }) => {
    const ref = useRef(null);
    const x = useMotionValue(0);
    const y = useMotionValue(0);

    const mouseXSpring = useSpring(x, {
        stiffness: 260,
        damping: 20,
    });
    const mouseYSpring = useSpring(y, {
        stiffness: 260,
        damping: 20,
    });

    const rotateX = useTransform(mouseYSpring, [-0.5, 0.5], ['10deg', '-10deg']);
    const rotateY = useTransform(mouseXSpring, [-0.5, 0.5], ['-10deg', '10deg']);

    const handleMouseMove = (e) => {
        if (!ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        const xPct = mouseX / width - 0.5;
        const yPct = mouseY / height - 0.5;
        x.set(xPct);
        y.set(yPct);
    };

    const handleMouseLeave = () => {
        x.set(0);
        y.set(0);
    };

    return (
        <motion.div
            ref={ref}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={{
                rotateX,
                rotateY,
                transformStyle: 'preserve-3d',
            }}
            className={`relative perspective-1000 ${className}`}
        >
            <div
                style={{
                    transform: 'translateZ(50px)',
                }}
                className="h-full w-full"
            >
                {children}
            </div>

            {/* Glossy reflection effect */}
            <motion.div
                style={{
                    transform: 'translateZ(60px)',
                    opacity: useTransform(mouseXSpring, [-0.5, 0.5], [0, 0.3]),
                }}
                className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent pointer-events-none rounded-2xl mix-blend-overlay"
            />
        </motion.div>
    );
};
